import { render, staticRenderFns } from "./TicketLayouts.vue?vue&type=template&id=337382c4&scoped=true"
import script from "./TicketLayouts.vue?vue&type=script&lang=js"
export * from "./TicketLayouts.vue?vue&type=script&lang=js"
import style0 from "./TicketLayouts.vue?vue&type=style&index=0&id=337382c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337382c4",
  null
  
)

export default component.exports